'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'dice-d20';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f6cf';
var svgPathData = 'M242.9 22.5L58 133.5l83.6 62.7L242.9 22.5zM48 146l0 213.9 85.6-149.7L48 146zM68.4 384.8L248 492.5l0-100.8L68.4 384.8zM264 492.5L443.6 384.8 264 391.7l0 100.8zM464 359.9L464 146l-85.5 64.2L464 359.9zM454 133.5l-185-111L370.4 196.2 454 133.5zM243.7 3.4c7.6-4.6 17.1-4.6 24.7 0l200 120c7.2 4.3 11.7 12.1 11.7 20.6l0 224c0 8.4-4.4 16.2-11.7 20.6l-200 120c-7.6 4.6-17.1 4.6-24.7 0l-200-120C36.4 384.2 32 376.4 32 368l0-224c0-8.4 4.4-16.2 11.7-20.6l200-120zm-2.6 372L144.4 223.5l-82.9 145 179.6 6.9zM353.4 216l-194.9 0L256 369.1 353.4 216zM256 31.9L157.9 200l196.1 0L256 31.9zm14.9 343.5l179.6-6.9-82.9-145L270.9 375.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiceD20 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;